export enum EnumBannerClass {
  info,
  warning,
  danger,
}

export interface IBanner {
  class: EnumBannerClass;
  message: string;
  canDismiss: boolean;
}
